import { Fragment } from 'react';

import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_FULL } from 'CorePackage/MainModule/constants/dateFormat';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';

import styles from './styles.module.scss';
import { IErpObjectResult } from '../../../ApiPackage/SearchModule/interfaces/IErpObjectResult';

interface IKnmResultProps {
  objectResult?: IErpObjectResult;
}

export const KnmErpObjectResult = ({ objectResult }: IKnmResultProps) => (
  <>
    {objectResult && (
      <>
        <span className={styles.SectionTitle}>Результат проведения КНМ</span>
        {objectResult.actCreateDate && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Дата и время составления акта о проведении КНМ</div>
            <div className={styles.ColValue}>
              {formatDate({ date: objectResult.actCreateDate, dateFormat: DATE_FORMAT_FULL })}
            </div>
          </div>
        )}
        {objectResult.notInFIAS !== undefined && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Иное указание места (нет в ФИАС)</div>
            <div className={styles.ColValue}>
              <Checkbox checked={objectResult.notInFIAS} size="medium" type="checkbox" theme="system" disabled={true} />
            </div>
          </div>
        )}
        {(objectResult.actAddress !== undefined || objectResult.manualAddress !== undefined) && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Место составления акта о проведении КНМ</div>
            <div className={styles.ColValue}>{objectResult.actAddress ?? objectResult.manualAddress}</div>
          </div>
        )}
        {objectResult.fiasRegion !== undefined && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Субъект РФ</div>
            <div className={styles.ColValue}>
              {typeof objectResult.fiasRegion === 'object' ? objectResult.fiasRegion.name : objectResult.fiasRegion}
            </div>
          </div>
        )}
        {objectResult.actAddressTypeName !== undefined && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Тип адреса места составления акта о проведении КНМ</div>
            <div className={styles.ColValue}>{objectResult.actAddressTypeName}</div>
          </div>
        )}
        {objectResult.startDate && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Дата начала проведения КНМ (фактическая)</div>
            <div className={styles.ColValue}>
              {formatDate({ date: objectResult.startDate, dateFormat: DATE_FORMAT_FULL })}
            </div>
          </div>
        )}
        {objectResult.durationDays && objectResult.durationDays > 0 && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Длительность КНМ (в днях)</div>
            <div className={styles.ColValue}>{objectResult.durationDays}</div>
          </div>
        )}
        {objectResult.durationHours && objectResult.durationHours > 0 && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Длительность КНМ (в часах)</div>
            <div className={styles.ColValue}>{objectResult.durationHours}</div>
          </div>
        )}
        {objectResult.representativeFullName && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Фамилия, имя, отчество (последнее – при наличии) руководителя, иного должностного лица юридического лица,
              уполномоченного представителя юридического лица, уполномоченного представителя индивидуального
              предпринимателя, присутствовавших при проведении КНМ
            </div>
            <div className={styles.ColValue}>{objectResult.representativeFullName}</div>
          </div>
        )}
        {objectResult.representativePosition && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Должность руководителя, иного должностного лица юридического лица, уполномоченного представителя
              юридического лица, уполномоченного представителя индивидуального предпринимателя, присутствовавших при
              проведении КНМ
            </div>
            <div className={styles.ColValue}>{objectResult.representativePosition}</div>
          </div>
        )}
        {objectResult.representativeTypeName && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Тип представителя проверяемого лица</div>
            <div className={styles.ColValue}>{objectResult.representativeTypeName}</div>
          </div>
        )}
        {objectResult.resultInformation
          ?.filter(item => item.typeCode === 'ACT_WAS_NOT_READ_NOTE')
          .map((item, resultInformationIndex) => {
            return (
              <div className={styles.Row} key={resultInformationIndex}>
                <div className={styles.ColText}>{item.typeName}</div>
                <div className={styles.ColValue}>{item.text}</div>
              </div>
            );
          })}
        {objectResult.actWasNotRead === false && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Отметка об ознакомлении или отказе от ознакомления с актом КНМ руководителя, иного должностного лица или
              уполномоченного представителя юридического лица, индивидуального предпринимателя, его уполномоченного
              представителя, присутствовавших при проведении КНМ, о наличии их подписей или об отказе от совершения
              подписи
            </div>
            <div className={styles.ColValue}>0</div>
          </div>
        )}
        {objectResult.wrongDataReasonSec && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Сведения о несоответствии информации, содержащейся в уведомлении о начале осуществления отдельных видов
              предпринимательской деятельности, обязательным требованиям (с указанием положений нормативных правовых
              актов)
            </div>
            <div className={styles.ColValue}>{objectResult.wrongDataReasonSec}</div>
          </div>
        )}
        {objectResult.absentViolationNote && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Указание на отсутствие выявленных нарушений обязательных требований или требований, установленных
              муниципальными правовыми актами (в случае если нарушений обязательных требований или требований,
              установленных муниципальными правовыми актами, не выявлено)
            </div>
            <div className={styles.ColValue}>{objectResult.absentViolationNote}</div>
          </div>
        )}
        {objectResult.unimpossibleReason && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Сведения о причинах невозможности проведения КНМ (в случае если КНМ не проведено)
            </div>
            <div className={styles.ColValue}>{objectResult.unimpossibleReason}</div>
          </div>
        )}
        {objectResult.undoigSec && (
          <div className={styles.Row}>
            <div className={styles.ColText}>
              Сведения об отмене результатов КНМ в случае, если такая отмена была произведена
            </div>
            <div className={styles.ColValue}>{objectResult.undoigSec}</div>
          </div>
        )}

        {objectResult.resultInformation && objectResult.resultInformation.length > 0 && (
          <>
            <span className={styles.SectionTitle}>Сведения о результате КНМ</span>
            {objectResult.resultInformation.map((res, resIndex) => (
              <Fragment key={resIndex}>
                <span className={styles.SectionTitle}>{`Сведения о результате №${resIndex + 1}`}</span>
                <div className={styles.Row}>
                  <div className={styles.ColText}>Тип сведений о результате</div>
                  <div className={styles.ColValue}>{res.typeName}</div>
                </div>
                <div className={styles.Row}>
                  <div className={styles.ColText}>Формулировка сведения о результате</div>
                  <div className={styles.ColValue}>{res.text}</div>
                </div>
              </Fragment>
            ))}
          </>
        )}
        {objectResult.resultInspector && objectResult.resultInspector.length > 0 && (
          <>
            <span className={styles.SectionTitle}>Список должностных лиц, проводивших КНМ</span>
            {objectResult.resultInspector.map((inspector, inspectorIndex) => (
              <Fragment key={inspectorIndex}>
                <span className={styles.SectionTitle}>
                  {`Фамилия, имя, отчество (последнее - при наличии) и должность должностного лица (должностных лиц), проводившего КНМ №${
                    inspectorIndex + 1
                  }`}
                </span>
                <div className={styles.Row}>
                  <div className={styles.ColText}>ФИО должностного лица, уполномоченного на проведение КНМ</div>
                  <div className={styles.ColValue}>{inspector.fullName}</div>
                </div>
                <div className={styles.Row}>
                  <div className={styles.ColText}>Должность должностного лица, уполномоченного на проведение КНМ</div>
                  <div className={styles.ColValue}>{inspector.position}</div>
                </div>
                <div className={styles.Row}>
                  <div className={styles.ColText}>Тип должностного лица, уполномоченного на проведение КНМ</div>
                  <div className={styles.ColValue}>{inspector.inspectorTypeName}</div>
                </div>
              </Fragment>
            ))}
          </>
        )}
        {objectResult.resultRepresentative && objectResult.resultRepresentative.length > 0 && (
          <>
            <span className={styles.SectionTitle}>Должностное лицо, присутствовавшее при проведении КНМ</span>
            {objectResult.resultRepresentative.map((rep, repIndex) => (
              <Fragment key={repIndex}>
                <span className={styles.SectionTitle}>
                  {`Должностное лицо, присутствовавшее при проведении КНМ №${repIndex + 1}`}
                </span>
                {rep.fullName && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>
                      Фамилия, имя, отчество (последнее - при наличии) и должность руководителя, иного должностного
                      лица, юридического лица, уполномоченного представителя юридического лица, уполномоченного
                      представителя индивидуального предпринимателя, присутствовавших при проведении КНМ
                    </div>
                    <div className={styles.ColValue}>{rep.fullName}</div>
                  </div>
                )}
                {rep.position && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>
                      Должность руководителя, иного должностного лица юридического лица, уполномоченного представителя
                      юридического лица, уполномоченного представителя индивидуального предпринимателя, присутствовавших
                      при проведении КНМ
                    </div>
                    <div className={styles.ColValue}>{rep.position}</div>
                  </div>
                )}
                {rep.typeName && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>
                      Тип представителя должностного лица, уполномоченного представителя юридического лица,
                      уполномоченного представителя индивидуального предпринимателя, присутствовавших при проведении КНМ
                    </div>
                    <div className={styles.ColValue}>{rep.typeName}</div>
                  </div>
                )}
              </Fragment>
            ))}
          </>
        )}
      </>
    )}
  </>
);
